const mllabelling=require('./mllabelling.json');
const drilling=require('./drilling.json');
const graphics=require('./graphics.json');
const telecom=require('./telecom.json');

module.exports = [mllabelling, drilling, telecom, graphics]